import { render } from "./AdvisorFloat.vue?vue&type=template&id=408a468c&scoped=true"
import script from "./AdvisorFloat.vue?vue&type=script&lang=js"
export * from "./AdvisorFloat.vue?vue&type=script&lang=js"

import "./AdvisorFloat.vue?vue&type=style&index=0&id=408a468c&scoped=true&lang=scss"

import exportComponent from "/usr/local/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-408a468c"]])

export default __exports__